import {
  ActivityResponse,
  DrawResultResponse,
  DrawSubmitPayload,
} from "../types/luckyDraw";

const API_BASE = "/api/draw";
async function handleResponse<T>(response: Response): Promise<T> {
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    const message =
      data?.message || `Request failed with status ${response.status}`;
    throw new Error(message);
  }

  return data as T;
}

export async function fetchActivityInfo(): Promise<ActivityResponse> {
  const response = await fetch(`${API_BASE}/activity/`, {
    method: "GET",
  });

  return handleResponse<ActivityResponse>(response);
}

export async function fetchDrawResult(
  phone: string
): Promise<DrawResultResponse> {
  const response = await fetch(
    `${API_BASE}/result/?phone=${encodeURIComponent(phone)}`,
    {
      method: "GET",
    }
  );

  return handleResponse<DrawResultResponse>(response);
}

export async function submitDraw(
  payload: DrawSubmitPayload
): Promise<DrawResultResponse> {
  const response = await fetch(`${API_BASE}/submit/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  return handleResponse<DrawResultResponse>(response);
}